import React, { useState } from "react";
import StudentLayout from "../../layouts/StudentLayout";
import Button from "../../components/common/Button";
import StudentHeaderSection from "../../components/student/StudentHeaderSection";

import { Clock, FilledDropDown } from "../../components/Icons";
import {
  QuizCardIcon1,
  QuizCardIcon2,
  QuizCardIcon3,
  QuizCardIcon4,
} from "../../components/student/StudentModuleIcons";
import ComingSoonOverlay from "../../components/ComingSoonOverlay";

const cards = [
  {
    icon: QuizCardIcon1,
    value: "5",
    title: "Total Quizzes",
    bg: "#DBEAFE",
  },
  {
    icon: QuizCardIcon2,
    value: "1",
    title: "Completed",
    bg: "#DCFCE7",
  },
  {
    icon: QuizCardIcon3,
    value: "2",
    title: "Available",
    bg: "#FFEDD5",
  },
  {
    icon: QuizCardIcon4,
    value: "2",
    title: "Locked",
    bg: "#F3F4F6",
  },
];

const statusOptions = ["All Quizzes", "Available", "Completed", "Locked"];

const Quiz = () => {
  const [filterStatus, setFilterStatus] = useState("All Quizzes");
  const [search, setSearch] = useState("");

  return (
    <StudentLayout>
      <div className="sm:block hidden">
        <StudentHeaderSection
          isBtnIcon={false}
          btnText="Logout"
        />
      </div>
      <div className="relative">
        <div className="pt-10 pb-20 px-6 sm:px-10 2xl:pl-[88px] 2xl:pr-10 font-['Roboto']">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-8">
            <h1 className="text-[26px] sm:text-[30px] leading-9 font-bold text-[#1F2937]">
              Quiz Dashboard
            </h1>
            <p className="text-sm text-[#4B5563]">
              Manage and track your course quizzes
            </p>
          </div>

          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-[0_1px_2px_0_#0000000D] border border-[#E5E7EB] mb-3 flex flex-col sm:flex-row gap-4 sm:gap-3 sm:items-center sm:justify-between">
            <div>
              <label className="text-sm block mb-2 font-medium text-[#374151]">
                Filter by Status
              </label>
              <div className="relative">
                <select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="px-3 w-full sm:w-[135px] bg-[#EFEFEF] py-[9px] border border-[#D1D5DB] rounded-lg text-sm leading-4 text-black appearance-none"
                >
                  {statusOptions.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <FilledDropDown color="#000" width="12" height="7" />
                </div>
              </div>
            </div>

            <div className="w-full sm:w-auto">
              <label className="text-sm block mb-2 font-medium text-[#374151]">
                Search Quizzes
              </label>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by quiz name, course, or module..."
                className="px-3 text-sm py-2 border border-[#D1D5DB] rounded-lg w-full md:w-[440px]"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-5">
            {cards.map((val, idx) => {
              const Icon = val.icon;
              return (
                <div
                  key={idx}
                  className="bg-white flex flex-col items-center p-6 rounded-lg shadow-[0_1px_2px_0_#0000000D] border border-[#E5E7EB] text-center"
                >
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-lg"
                    style={{ backgroundColor: val.bg }}
                  >
                    <Icon />
                  </div>
                  <div className="mt-3 text-2xl font-bold text-[#1F2937]">
                    {val.value}
                  </div>
                  <div className="mt-1 text-sm text-[#4B5563]">{val.title}</div>
                </div>
              );
            })}
          </div>

          <div className="bg-white rounded-lg shadow-[0_1px_2px_0_#0000000D] border border-[#E5E7EB] overflow-hidden p-4 sm:p-6">
            <div className="w-full overflow-x-auto">
              <table className="min-w-[900px] w-full">
                <thead className="bg-white">
                  <tr className="text-left border-b border-[#E5E7EB] [&>th]:px-3 [&>th]:sm:px-6 [&>th]:py-3 [&>th]:sm:py-4 [&>th]:text-sm [&>th]:sm:text-base [&>th]:font-semibold [&>th]:text-[#1F2937] [&>th]:whitespace-nowrap">
                    <th>Course</th>
                    <th>Module</th>
                    <th>Quiz Title</th>
                    <th>Duration</th>
                    {/* <th>Availability</th> */}
                    <th>Status</th>
                    <th>Score</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {[].map((q) => (
                    <tr key={q._id} className="border-b border-[#F3F4F6]">
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm sm:text-base font-medium text-[#1F2937]">
                        {q.course?.courseTitle || "-"}
                      </td>
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm sm:text-base text-[#4B5563]">
                        {q.course?.courseTitle || "-"}
                      </td>
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm max-w-52">
                        <div className="font-medium text-sm sm:text-base text-[#1F2937]">
                          {q.title}
                        </div>
                        <div className="text-[#6B7280] truncate">
                          {q.description}
                        </div>
                      </td>
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm sm:text-base text-[#4B5563] whitespace-nowrap">
                        <span className="inline-flex items-center gap-1">
                          <Clock /> {q.settings?.timeLimitMinutes ?? "-"} min
                        </span>
                      </td>
                      {/* <td className="px-6 py-5 align-top text-sm text-[#4B5563]">
                    {q.availability}
                  </td> */}
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm font-medium">
                        {/* {q.status === "Available" && */}{" "}
                        {true && (
                          <span className="bg-[#DBEAFE] text-[#1E40AF] px-3 py-1 rounded-full whitespace-nowrap">
                            Available
                          </span>
                        )}
                        {/* {q.status === "Locked" && (
                      <span className="bg-[#F3F4F6] text-[#4B5563] px-3 py-1 rounded-full">
                        Locked
                      </span>
                    )} */}
                        {/* {q.status === "Completed" && (
                      <span className="bg-green-100 text-[#166534] px-3 py-1 rounded-full text-sm">
                        Completed
                      </span>
                    )} */}
                        <span className="block text-center text-[10px] text-[#716f6f] mt-0.5">
                          Attempts: {q.settings?.attemptsAllowed ?? "-"}
                        </span>
                      </td>
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm font-medium text-[#1F2937] whitespace-nowrap">
                        {q.score || "-"}
                      </td>
                      <td className="px-3 sm:px-6 py-4 sm:py-5 align-top text-sm font-medium whitespace-nowrap">
                        {/* {q.status === "Available"*/}{" "}
                        {true && (
                          <Button
                            btnText={"Attempt Quiz"}
                            btnClassName="bg-[#FF6636] text-white px-3 py-1.5 rounded-lg"
                          />
                        )}
                        {/* {q.status === "Locked" && (
                      <button
                        className="px-3 opacity-50 py-1.5 bg-[#F3F4F6] text-[#111827] rounded-lg"
                        disabled
                      >
                        Locked
                      </button>
                    )}
                    {q.status === "Completed" && (
                      <button className="px-3 py-1.5 text-sm bg-white border border-[#D1D5DB] text-[#374151] rounded-lg">
                        View Results
                      </button>
                    )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ComingSoonOverlay
          title="Quiz Dashboard"
          description="We're putting the finishing touches on the Quiz Dashboard. Soon you'll be able to attempt quizzes, view your progress, and track your results."
        />
      </div>

     
    </StudentLayout>
  );
};

export default Quiz;
